// src/pages/SodaSuccessPage.jsx
import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SodaSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id') || 'Unknown';

  // Color palette to match your existing styles
  const colorPalette = {
    primary: "#4F46E5", // Indigo
    accent: "#EF4444",  // Red accent from existing code
    background: "#FFFFFF",
    text: "#111827",
    textLight: "#6B7280"
  };

  return (
    <div style={{ backgroundColor: colorPalette.background, color: colorPalette.text }}>
      <div className="max-w-2xl mx-auto px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="flex justify-center mb-8">
          <CheckCircle
            size={64}
            className="text-green-500"
          />
        </div>

        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Thank You!</h1>
          <p className="text-xl" style={{ color: colorPalette.textLight }}>
            Your purchase was successful
          </p>
          {orderId !== 'Unknown' && (
            <p className="text-sm mt-4" style={{ color: colorPalette.textLight }}>
              Order #{orderId}
            </p>
          )}
        </div>

        <div className="border rounded-lg overflow-hidden p-6 text-center"
          style={{ borderColor: `${colorPalette.textLight}20` }}>
          <h2 className="text-2xl font-medium mb-4">Please grab your item!</h2>
          <p className="mb-4">Thanks for quenching your thirst with us today.</p>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm" style={{ color: colorPalette.textLight }}>
            Have questions/feedback? Go to the #office-terminal-dogfooding slack channel.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SodaSuccessPage;